import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['vendor', 'map', 'addr', 'coordy', 'coordx'];

  static values = { xcenter: String, ycenter: String };
  

  connect() {
    // 다음 주소 검색(주소 -> 좌표)
    this.geocoder = new kakao.maps.services.Geocoder();
    if (!this.hasMapTarget) {
      return;
    }

    this.vendor = this.vendorTarget.value;
    this.imageSrc = '/images/icon-marker.png'; //마커이미지의 주소입니다
    this.infowindowDiv = '<div style="width:150px;text-align:center;padding:6px 0;">위치</div>';

    if (this.vendor == 'KAKAO') {
      this.map = new kakao.maps.Map(this.mapTarget, {
        center: new kakao.maps.LatLng(this.ycenterValue, this.xcenterValue), 
        level: 3, //지도의 확대 레벨
      });
    } else if (this.vendor == 'GOOGLE') {
      this.map = new google.maps.Map(this.mapTarget, {
        center: new google.maps.LatLng(this.ycenterValue, this.xcenterValue),
        zoom: 17,
      });

      // 장소 검색
      // submit 방지
      google.maps.event.addDomListener(this.addrTarget, 'keydown', function(event) { 
        if (event.keyCode === 13) { 
            event.preventDefault(); 
        }
      });

      const autocomplete = new google.maps.places.Autocomplete(this.addrTarget, {
        fields: ["formatted_address", "geometry", "name"],
        strictBounds: false,
        types: ["establishment"],
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        this.coordxTarget.value = place.geometry.location.lng();
        this.coordyTarget.value = place.geometry.location.lat();
        this.drawMarker();
      });
    }
  }

  
  drawMarker() {
    if (this.vendor == 'KAKAO') {
      const imageSize = new kakao.maps.Size(32, 44); //마커이미지의 크기입니다

      const position = new kakao.maps.LatLng(this.coordyTarget.value, this.coordxTarget.value);
      const marker = new kakao.maps.Marker({
        map: this.map,
        position: position,
        image: new kakao.maps.MarkerImage(this.imageSrc, imageSize),
      });

      new kakao.maps.InfoWindow({
        content: this.infowindowDiv,
      }).open(this.map, marker);

      this.map.setCenter(position);

    } else if (this.vendor == 'GOOGLE') {

      const position = new google.maps.LatLng(this.coordyTarget.value, this.coordxTarget.value)
      const marker = new google.maps.Marker({
        position: position,
        map: this.map,
        icon: {
          url: this.imageSrc,
          scaledSize: new google.maps.Size(32, 44),
        }
      });

      new google.maps.InfoWindow({
        content: this.infowindowDiv,
      }).open({
        anchor: marker,
        map: this.map,
      });
      this.map.setCenter(position);
    }
  }

  // 주소 검색
  search() {
    if (this.vendor == 'KAKAO') {
      new daum.Postcode({
        oncomplete: this.onSearch.bind(this),
      }).open();
    }
  }

  // 주소 검색 완료시 "주소", "좌표" 세팅
  onSearch(data) {
    this.addrTarget.value = data.address;
    if (!this.hasMapTarget) {
      return;
    }

    // 주소로 좌표를 검색합니다
    this.geocoder.addressSearch(data.address, (result, status) => {
      if (status === kakao.maps.services.Status.OK) {
        this.coordxTarget.value = result[0].x;
        this.coordyTarget.value = result[0].y;
        this.drawMarker();
      }
    });  
  }
}
